<template>
  <div>
    <div
      class="page-header page-header-bg"
      style="background-image: url('assets/images/banners/banner-top.jpg')"
    >
      <div class="container">
        <h1>{{ translations.brands }}</h1>
      </div>
      <!-- End .container -->
    </div>
    <!-- End .page-header -->
    <div class="features-section">
      <div class="container">
        <div class="row">
          <router-link class="col-md-4 col-xs-6" v-for="item in brands" :key="item.id"
            :to="{
                  name: 'Brand',
                  params: {
                    id: item.id,
                    title: item.title.replace(/\s+/g, '-')
                  }
                }"
                @click.prevent="safeTrackConversionForBrand(item.id, item.title)">
            <div class="feature-box other-brand wrapper-btn">
                <img
                  :src="`${baseUrl}${item.imageUrl}`"
                  :alt="item.title"
                  class="brand-image"
                />
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <!-- End .features-section -->
  </div>
</template>

<script>
import config from '@/config';
import { translations } from '@/mixins';

export default {
  name: 'Brands',
  mixins: [translations],
  computed: {
    baseUrl() {
      return config.baseUrl;
    },
    brands() {
      return this.$store.getters.getAllBrands;
    },
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.$store.dispatch('getAllBrands');
  },
};
</script>
